import { api } from "@/lib/api";

export async function runLinkHealthCheck(pageId) {
  try {
    const { data } = await api.post(`/pages/${pageId}/check-links`);
    return (data.links || []).filter((l) => l.status === "broken");
  } catch {
    return [];
  }
}
